import { useEffect, useRef, useState } from "react";
import { materialImage } from "../../api/materialParsing";

export default function MaterialSourceImage({ url, authToken, alt, onLoad, eager = false, ...props }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(eager || typeof IntersectionObserver === "undefined");
  const [source, setSource] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    if (visible || !ref.current) return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setVisible(true); observer.disconnect(); }
    }, { rootMargin: "200px" });
    observer.observe(ref.current); return () => observer.disconnect();
  }, [visible]);
  useEffect(() => {
    setSource(""); setError("");
    if (!visible || !url) return undefined;
    const controller = new AbortController(); let active = true; let objectUrl;
    materialImage(url, { authToken, signal: controller.signal }).then((blob) => {
      if (!active) return;
      objectUrl = URL.createObjectURL(blob); setSource(objectUrl);
    }).catch((failure) => { if (active) setError(failure.message); });
    return () => { active = false; controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [visible, url, authToken]);
  return <div ref={ref} className="material-protected-image">
    {source ? <img {...props} src={source} alt={alt} onLoad={onLoad} draggable={false} />
      : <span role={error ? "status" : undefined}>{error || (url ? "載入圖片…" : "尚無預覽")}</span>}
  </div>;
}
